import { Navigate } from "react-router-dom";

/**
 * The Performance page was split into /financials and /crm (Metrics is
 * hidden for now). Old /performance links and bookmarks land on the
 * matching page.
 */
export default function PerformanceRedirect() {
  const hash = window.location.hash;
  return <Navigate to={hash === "#crm" ? "/crm" : "/financials"} replace />;
}
